import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import themeGet from '@styled-system/theme-get';

import { NewTilesDigestModal } from '../NewTilesDigestModal';

const StyledCalendarWrapper = styled.div`
  margin: ${props => props.margin || '0px 0px 26px 0px'};

  @media screen and (max-width: 800px) {
    width: ${props => (props.margin ? '28px' : '46px')};
    height: ${props => (props.margin ? '28px' : '46px')};
  }
`;

const CalendarPlusIcon = styled.i`
  ${({ smallCalendar }) => !smallCalendar && 'font-size: 2.5em;'}
`;

CalendarPlusIcon.defaultProps = {
  className: 'fa-light fa-calendar-plus'
}

const TextDiv = styled.div`
  color: ${({ color }) => themeGet(`colors.${color}`)};
  cursor: pointer;
  text-align: ${props => props.textAlign || 'center'};
  font-size: ${props => props.textSize || '18px'};
  font-weight: 500;
  font-family: 'Montserrat';
  display: flex;
  align-items: center;
  ${({ isVertical }) => isVertical && 'flex-direction: column;'}
`;

const CreateDigestText = styled.div`
  display: inline;

  @media screen and (max-width: 800px) {
    display: ${props => (props.textSize ? 'none' : 'inline')};
  }
`;

export const CreateDigestButton = ({
  addTileDigest,
  smallCalendar,
  initialDate,
  marginCalendar,
  shouldBreak,
  textAlign,
  textSize,
  position,
}) => {
  const isVertical = !smallCalendar;
  const [currentColor, setCurrentColor] = useState('primary.100');
  return (
    <NewTilesDigestModal
      position={position}
      initialDate={initialDate}
      onConfirm={addTileDigest}
    >
      <TextDiv
        isVertical={isVertical}
        textAlign={textAlign}
        textSize={textSize}
        color={currentColor}
        onMouseEnter={() => setCurrentColor('primary.80')}
        onMouseLeave={() => setCurrentColor('primary.100')}
        onMouseDown={() => setCurrentColor('primary.120')}
        onMouseUp={() => setCurrentColor('primary.80')}
      >
        <StyledCalendarWrapper margin={marginCalendar}>
          <CalendarPlusIcon
            color={currentColor}
            smallCalendar={smallCalendar}
          />
        </StyledCalendarWrapper>
        {shouldBreak && <br />}
        <CreateDigestText textSize={textSize}>Create Digest</CreateDigestText>
      </TextDiv>
    </NewTilesDigestModal>
  );
};

CreateDigestButton.propTypes = {
  addTileDigest: PropTypes.func,
  smallCalendar: PropTypes.bool,
  initialDate: PropTypes.string,
  marginCalendar: PropTypes.string,
  shouldBreak: PropTypes.bool,
  textAlign: PropTypes.string,
  textPaddingTop: PropTypes.string,
  textPaddingRight: PropTypes.string,
  textSize: PropTypes.string,
  position: PropTypes.string,
};
